import React from 'react';

/** Lazy ClientComputedSocialMetadata (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedSocialMetadata = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-social-metadata' */
            './ConnectedClientComputedSocialMetadata'
        ),
);
